export enum CHANNELS {
  INSTAGRAM = "instagram",
  WHATSAPP = "whatsapp",
  EMAIL = "email",
  LIVECHAT = "livechat",
  TASKS = "tasks",
}

export const isValidChannel = (channel: string) => {
  if (
    channel === CHANNELS.INSTAGRAM ||
    channel === CHANNELS.WHATSAPP ||
    channel === CHANNELS.EMAIL ||
    channel === CHANNELS.LIVECHAT
  ) {
    return true;
  }
  return false;
};
